module.exports = __webpack_public_path__ + "img/sml_health_tips_icon.1ad4d63.png";